/**
 * 사회적 증거 섹션 — 실제 운영 채널 사례 + 통계.
 *
 * Server Component (인터랙션 없음). 사례는 props가 아닌 모듈 상수에서 관리해
 * 운영팀이 PR 한 번으로 갱신 가능하게 했다.
 *
 * NOTE: 임베드 ID는 현재 placeholder. 실제 영상 ID로 갱신 필요.
 */

import { TrendingUp } from 'lucide-react';
import { AppCard } from '@/components/common';

interface ChannelCase {
  channelName: string;
  tagline: string;
  videoEmbedId: string; // YouTube videoId
  monthlyVideos: string;
  cumulativeViews: string;
}

const CHANNEL_CASES: ChannelCase[] = [
  {
    channelName: 'deep hour',
    tagline: 'Music for your deepest focus',
    videoEmbedId: 'dQw4w9WgXcQ', // TODO: 실제 영상 ID로 교체
    monthlyVideos: '월 12편+',
    cumulativeViews: '누적 조회수 N만',
  },
  {
    channelName: 'Grooveline',
    tagline: 'Work · Chill · Move · Drive',
    videoEmbedId: 'dQw4w9WgXcQ', // TODO: 실제 영상 ID로 교체
    monthlyVideos: '월 8편+',
    cumulativeViews: '누적 조회수 N만',
  },
];

export function SocialProofSection() {
  return (
    <section className="bg-neutral-50 border-y border-neutral-100">
      <div className="max-w-6xl mx-auto px-4 py-12 sm:py-16">
        <div className="text-center mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-neutral-900 mb-3">
            이미 운영되고 있는 채널들
          </h2>
          <p className="text-neutral-600">
            Auto-Playlist로 매주 새 영상을 올리고 있는 실제 음악 채널 사례
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {CHANNEL_CASES.map((c) => (
            <AppCard key={c.channelName} className="p-4 sm:p-5 overflow-hidden">
              <div className="aspect-video bg-neutral-100 rounded-lg overflow-hidden mb-4">
                <iframe
                  src={`https://www.youtube.com/embed/${c.videoEmbedId}`}
                  title={`${c.channelName} 사례 영상`}
                  className="w-full h-full"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
              <h3 className="text-base font-semibold text-neutral-900">{c.channelName}</h3>
              <p className="text-sm text-neutral-500 mb-3">{c.tagline}</p>
              <div className="flex items-center gap-3 text-xs text-neutral-600">
                <span className="flex items-center gap-1">
                  <TrendingUp className="w-3.5 h-3.5 text-purple-500" />
                  {c.monthlyVideos}
                </span>
                <span className="text-neutral-300">·</span>
                <span>{c.cumulativeViews}</span>
              </div>
            </AppCard>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SocialProofSection;
